import { render, staticRenderFns } from "./faqtable.vue?vue&type=template&id=8587f3ae&scoped=true"
import script from "./faqtable.vue?vue&type=script&lang=js"
export * from "./faqtable.vue?vue&type=script&lang=js"
import style0 from "./faqtable.vue?vue&type=style&index=0&id=8587f3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8587f3ae",
  null
  
)

export default component.exports